// #region License

/**
 * @license
 * Copyright (C) Mairistem
 *
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 *
 * Proprietary and confidential
 */

// #endregion

/* eslint-disable */

import * as React from "react";
import { Container, Menu, Segment } from "semantic-ui-react";
import ApplicationLoader from "../../../components/ApplicationLoader";
import { getClassName } from "../../../components/utils/className";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export const DashboardWidget = props => {
  const {
    identifiant,
    nom,
    composant,
    overlay,
    onDrag,
    onRemove
  } = props;
  const container = React.useRef();
  const id = React.useId();
  const handleClose = React.useCallback(() => {
    onRemove?.(identifiant);
  }, [identifiant, onRemove]);
  const component = React.useMemo(() => /*#__PURE__*/React.createElement(/*#__PURE__*/React.lazy(() => import(`./widgets/${composant || "Default"}`))), [composant]);
  const menu = React.useMemo(() => /*#__PURE__*/_jsxs(Menu, {
    secondary: true,
    children: [/*#__PURE__*/_jsx(Menu.Item, {
      header: true,
      children: nom
    }), /*#__PURE__*/_jsxs(Menu.Menu, {
      className: "actions",
      position: "right",
      children: [/*#__PURE__*/_jsx(Menu.Item, {
        as: "a",
        icon: "arrows alternate",
        ...onDrag,
        style: {
          cursor: "grab"
        }
      }), /*#__PURE__*/_jsx(Menu.Item, {
        icon: "close",
        onClick: handleClose
      })]
    })]
  }), [nom, onDrag]);
  const content = React.useMemo(() => /*#__PURE__*/_jsx(Container, {
    fluid: true,
    children: /*#__PURE__*/_jsx("article", {
      ref: container,
      children: /*#__PURE__*/_jsx(React.Suspense, {
        fallback: /*#__PURE__*/_jsx(ApplicationLoader, {}),
        children: component
      })
    })
  }), [component]);
  return /*#__PURE__*/_jsxs(Segment, {
    className: getClassName("dashboard-widget", {
      overlay
    }),
    raised: overlay,
    "data-sentry-element": "Segment",
    "data-sentry-component": "DashboardWidget",
    "data-sentry-source-file": "DashboardWidget.tsx",
    children: [menu, content]
  });
};
export default DashboardWidget;